import { CommandDescriptor } from '../../types/commandTypes'
import { axiosClient } from '../axiosClient'

export const commandFunctions = {
  /** Fetch the slash-command registry. See `GET /api/commands` (PR3). */
  async fetchCommands(): Promise<CommandDescriptor[]> {
    return axiosClient.get('/api/commands')
  },
}
